export const UPDATE = 'LOCALE/UPDATE'
